'use strict'

import PropTypes from 'prop-types'
import React from 'react'
import './ScopeSelection.less'

const classNames = require('classnames')

const USER_SCOPE = 'user'
const DEVICES_SCOPE = 'devices'
const HOUSEHOLD_SCOPE = 'household'

const ScopeSelectionText = ({children, type, onClick, selected, value}) => {
  const isSelected = value === selected
  const classes = classNames(`nmc-scope-selection nmc-scope-selection-${type}`, {
    'nmc-scope-selected': isSelected
  })
  let childrenWithProps = null
  if (React.isValidElement(children)) {
    childrenWithProps = React.Children.map(children,
      (child) => React.cloneElement(child, {
        selected: isSelected
      })
    )
  }
  return <span onClick={onClick} className={classes}>{childrenWithProps || children}</span>
}

const ScopeSelection = ({onChange, selected, userText, devicesText, householdText, disableUserScope, disableDevicesScope, disableHouseholdScope, scopeValues}) => {
  const userScopeValue = scopeValues.user
  const devicesScopeValue = scopeValues.devices
  const householdScopeValue = scopeValues.household
  const classes = classNames('nmc-scope-image', {
    'nmc-scope-selection-user-selected': selected === userScopeValue,
    'nmc-scope-selection-devices-selected': selected === devicesScopeValue,
    'nmc-scope-selection-household-selected': selected === householdScopeValue
  })

  return (
    <div className='nmc-scope-selection'>
      <span className={classes} />
      {disableUserScope || <ScopeSelectionText selected={selected} type={USER_SCOPE} value={userScopeValue} onClick={() => (onChange(userScopeValue))}>{userText}</ScopeSelectionText>}
      {disableDevicesScope || <ScopeSelectionText selected={selected} type={DEVICES_SCOPE} value={devicesScopeValue} onClick={() => (onChange(devicesScopeValue))}>{devicesText}</ScopeSelectionText>}
      {disableHouseholdScope || <ScopeSelectionText selected={selected} type={HOUSEHOLD_SCOPE} value={householdScopeValue} onClick={() => (onChange(householdScopeValue))}>{householdText}</ScopeSelectionText>}
    </div>
  )
}

ScopeSelection.propTypes = {
  onChange: PropTypes.func,
  userText: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  devicesText: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  householdText: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  disableUserScope: PropTypes.bool,
  disableDevicesScope: PropTypes.bool,
  disableHouseholdScope: PropTypes.bool,
  scopeValues: PropTypes.shape({
    user: PropTypes.string.isRequired,
    devices: PropTypes.string.isRequired,
    household: PropTypes.string.isRequired
  })
}

ScopeSelection.defaultProps = {
  onChange: () => false,
  selected: null,
  userText: '',
  devicesText: '',
  householdText: '',
  disableUserScope: false,
  disableDevicesScope: false,
  disableHouseholdScope: false,
  scopeValues: {
    user: USER_SCOPE,
    devices: DEVICES_SCOPE,
    household: HOUSEHOLD_SCOPE
  }
}

export default ScopeSelection



// WEBPACK FOOTER //
// ../~/@master/webinfra-frontend-components/src/components/ScopeSelection/index.js